import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BancoService } from 'src/app/services/banco.service';
import { ControlResumidoService } from 'src/app/services/control-resumido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'
import { CuentaBancariaService } from 'src/app/services/cuenta-bancaria.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { RutService } from 'src/app/shared/services/rut.service';

export interface HeaderParams {
  fecha_desde: Date;
  fecha_hasta: Date;
}
@Component({
  selector: 'app-deposito-efectivo-control-resumido',
  templateUrl: './control-resumido.component.html',
  styleUrls: ['./control-resumido.component.scss'],
  providers: [SecurityService],
})
export class ControlResumidoComponent implements OnInit {

  @Input() paginationContext: PaginationContext = new PaginationContext()

  private _listaResumen: Array<any> = null
  @Input()
  set listaResumen(value: Array<any> | null) {
    this._listaResumen = value
    this.calcularTotal()
  }
  get listaResumen(): Array<any> {
    return this._listaResumen
  }


  @Output() onPageChange: EventEmitter<PaginationContext> = new EventEmitter<PaginationContext>()

  // Form
  formDepositante: FormGroup

  // Data & Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  optionsBanco: Array<any> = [];
  optionsCuenta: Array<any> = [];
  totalResumen: number = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private controlResumidoService: ControlResumidoService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private bancoService: BancoService,
    private cuentaBancariaService: CuentaBancariaService,
    private rutService: RutService
  ) {
    this.log = this.clog.log('DEPOSITO-EFECTIVO-DEPOSITO-EFECTIVO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.getBancos()

    this.createForm()
    this.formChangesSubscriptions()
  }

  private getBancos() {
    this.bancoService.obtenerBancoEmpresas(
      this.rutEmpresa,
      true,
      ({ mensajes, respuesta }) => {
        const { registros } = respuesta
        this.optionsBanco = registros.map(banco => ({ value: banco.codigo, label: banco.nombre, ...banco }))
      }
    )
  }

  private createForm() {
    this.formDepositante = this.fb.group({
      rut: [null, [Validators.required]],
      nombre: [null, [Validators.required]],
      banco: [null, [Validators.required]],
      cuenta: [null, [Validators.required]],
      numeroDeposito: [null, [Validators.required]],
      fechaDeposito: [null, [Validators.required]],
    });
  }

  formChangesSubscriptions() {
    this.formDepositante.get("banco").valueChanges.subscribe(banco_codigo => {
      this.getCuentas(banco_codigo)
    })
  }

  getCuentas(banco_codigo) {
    this.cuentaBancariaService.obtenerCuentaEmpresa(
      this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
        const { registros } = respuesta
        this.formDepositante.get('cuenta').setValue(null)
        this.formDepositante.get('cuenta').markAsPristine()
        this.formDepositante.get('cuenta').markAsUntouched()
        this.optionsCuenta = registros.map(cuenta => ({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta, ...cuenta }))
      })
  }

  handlePageChange(context: PaginationContext) {
    this.log('handlePageChange', context)
    // this.paginationContext.CurrentPage = context.RequestedPage
    this.onPageChange.emit(context)
    // this.buscar()
  }

  checkAllChange({ checked }) {
    this.listaResumen.forEach(detalle => { detalle.seleccion = checked })
    this.calcularTotal()
  }

  checkDetalle({ index }) {
    const selected = this.listaResumen.filter(p => p.index === index)[0]
    selected.seleccion = !selected.seleccion
    this.calcularTotal()
  }

  calcularTotal() {
    if (!this.listaResumen)
      return

    const listaResumen = _.cloneDeep(this.listaResumen)
    listaResumen.map(item => {
      delete item.index
      delete item.__typename
    })
    const inputParams = {
      entidad: {
        lista: listaResumen
      }
    }
    this.log('inputParams', JSON.stringify(inputParams))
    this.controlResumidoService.obtenerControlResumenTotalEfectivo(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { total_resumen } = respuesta
      this.totalResumen = total_resumen
      this.log('totalResumen', this.totalResumen)
    })
  }

  public validate(): Boolean {
    this.formValidatorsService.validateAllFormFields(this.formDepositante)

    if (!this.listaResumen) return false

    const seleccionados = this.listaResumen.filter(p => p.seleccion)
    if (seleccionados.length === 0) {
      this.toastrService.warning('Seleccione registro(s)')
      return false
    }

    if (!this.formDepositante.valid)
      return false

    return true
  }

  public getControlResumido() {
    const listaResumen = _.cloneDeep(this.listaResumen)
    listaResumen.map(item => {
      delete item.index
      delete item.__typename
    })

    const cuenta = this.optionsCuenta.filter(cuenta => this.formDepositante.get('cuenta').value === cuenta.numero_cuenta)[0]

    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        tipo_cuenta_bancaria_codigo: cuenta.tipo_cuenta_bancaria_codigo,
        banco_codigo: this.formDepositante.get("banco").value,
        numero_cuenta: this.formDepositante.get("cuenta").value,
        fecha_deposito: this.formDepositante.get("fechaDeposito").value,
        depositante_rut: this.rutService.QuitarDV(this.formDepositante.get("rut").value),
        depositante_nombre: this.formDepositante.get("nombre").value,
        numero_deposito: this.formDepositante.get("numeroDeposito").value,
        // "monto": 50
        // monto: this.totalResumen
      },
      resumen: {
        lista: listaResumen
      }
    }
  }

  clear() {
    this.formDepositante.reset()
    this.formDepositante.get('rut').setValue(null)
    this.formDepositante.get('nombre').setValue(null)
    this.formDepositante.get('banco').setValue(null)
    this.formDepositante.get('cuenta').setValue(null)
    this.formDepositante.get('numeroDeposito').setValue(null)
    this.formDepositante.get('fechaDeposito').setValue(null)
    this.formDepositante.markAsUntouched()
    this.formDepositante.markAsPristine()

    this._listaResumen = null

    this.optionsCuenta = [];
    this.totalResumen = null
  }

}
